// src/services/authService.js
import { createUserWithEmailAndPassword, updateProfile, getAuth, signOut } from "firebase/auth";
import { initializeApp, getApps } from "firebase/app";

// Secondary Firebase app instance used only for creating driver accounts.
// This prevents Firebase from signing in the new user and replacing the admin session.
const firebaseConfig = {
  apiKey: "AIzaSyDuvA6OU_Zy29kF2nDrutkDpaFun9rdDqU",
  authDomain: "be-car-check.firebaseapp.com",
  projectId: "be-car-check",
  storageBucket: "be-car-check.firebasestorage.app",
  messagingSenderId: "324674561731",
  appId: "1:324674561731:web:5c9b931b10b8c111862476",
};

const secondaryApp = getApps().find(a => a.name === 'secondary') || initializeApp(firebaseConfig, 'secondary');
const secondaryAuth = getAuth(secondaryApp);

// Generate a simple password: name + @ + 4 random numbers
export const generatePassword = (name) => {
  const cleanName = name.toLowerCase().replace(/\s+/g, "");
  const shortName = cleanName.slice(0, 4); // take only first 4 chars
  const randomNumbers = Math.floor(1000 + Math.random() * 9000);
  return `${shortName}@${randomNumbers}`;
};

// Create Firebase Auth user for driver using a secondary app instance
// so the admin's session is never replaced.
export const createDriverAccount = async (driverData) => {
  try {
    const { name, email } = driverData;
    const password = generatePassword(name);

    const userCredential = await createUserWithEmailAndPassword(secondaryAuth, email, password);
    const user = userCredential.user;

    await updateProfile(user, { displayName: name });

    // Sign out from secondary instance immediately — we only needed the UID
    await signOut(secondaryAuth);

    return {
      uid: user.uid,
      email: user.email,
      password,
      success: true,
    };
  } catch (error) {
    console.error("Error creating driver account:", error);
    throw new Error(`Failed to create account: ${error.message}`);
  }
};
